export default {
    namespaced: true,
    state: {
        data: {},
        currentSiteId: null,
        domain: '',
        groups: [],
        yandexRegionList: [],
        googleRegionList: [],
    },
    getters: {
        DATA: state => {
            return state.data;
        },
        CURRENT_SITE_ID: state => {
            return state.currentSiteId;
        },
        DOMAIN: state => {
            return state.domain;
        },
        GROUPS: state => {
            return state.groups;
        },
        YANDEX_REGION_LIST: state => {
            return state.yandexRegionList;
        },
        GOOGLE_REGION_LIST: state => {
            return state.googleRegionList;
        },
    },
    mutations: {
        DOMAIN: (state, payload) => {
            return state.domain = payload;
        },
        DATA: (state, payload) => {
            return state.data = payload;
        },
        CURRENT_SITE_ID: (state, payload) => {
            return state.currentSiteId = payload;
        },
        GROUPS: (state, payload) => {
            return state.groups = payload;
        },
        YANDEX_REGION_LIST: (state, payload) => {
            return state.yandexRegionList = payload;
        },
        GOOGLE_REGION_LIST: (state, payload) => {
            return state.googleRegionList = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site/' + state.currentSiteId,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.data = responseData.data
                    state.domain = responseData.data.domain
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },

        SAVE: async ({state}, payload) => {

            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                    url: '/site/'+ state.currentSiteId,
                    parameter: state.data,
                    th: payload.th,
                    showSuccessMessage: true,
                    getSuccessResponse: (responseData) => {
                        console.log(responseData)
                    },
                    getResponse: () => {
                        state.isSendingSAVE = false;
                        payload.th.showOverlay --;
                    }
                });
        },

        GET_GROUPS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-groups',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('GROUPS', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_YANDEX_REGIONS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            let params = {
                'searchEngine': 'yandex',
            }
            params = JSON.stringify(params);
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/search-region-names?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('YANDEX_REGION_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_GOOGLE_REGIONS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            let params = {
                'searchEngine': 'google',
            }
            params = JSON.stringify(params);
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/search-region-names?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('GOOGLE_REGION_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
    }
}